  <mat-accordion>
    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title>Documents ({{ documents.length }})</mat-panel-title>
        <mat-panel-description>Documentation attached to {{ attachedToType| titlecase }} </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-card style="width:auto">
        <mat-card-content>
          <mat-list role="list">
            <mat-list-item role="listitem" *ngFor="let d of documents; let i=index">
              <div class="center-align">
                {{ i+1 }}
                <aims-file-upload name="Documentation" style="margin-left: 10px;"
                      fileName={{d.fileAttachmentName}}
                      [saveUrl]="'Inventory/SaveDocument?attachedToId='+attachedToId+'&attachedToType='+attachedToTypeId"
                      [removeUrl]="'Inventory/DeleteDocument?fileAttachmentId='+d.fileAttachmentId"
                      [downloadUrl]="'Inventory/DisplayDocument?fileAttachmentId='+d.fileAttachmentId"
                      (success)="rowAdded()"
                      (fileDeleted)="rowDeleted()"
                      allowedFileType="allowedExtensions"
                      maxFileSize="maxFileSize">
                </aims-file-upload>
              </div>
            </mat-list-item>
          </mat-list>
        </mat-card-content>
        <mat-card-actions>
          <aims-common-button
            title="Add Document"
            aria-label="Add Document"
            [disabled]="disableAddButton()"
            (click)="addRowClick()">
            <mat-icon color="primary">library_add</mat-icon>
          </aims-common-button>
        </mat-card-actions>
      </mat-card>
    </mat-expansion-panel>
  </mat-accordion>
